// extracted by mini-css-extract-plugin
export default {"FormContainer":"Transaction_FormContainer__fHx1W","MainContainer":"Transaction_MainContainer__qfLWA","InputGroup":"Transaction_InputGroup__cM0mW","Title":"Transaction_Title__IlyJr"};